// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2bqSw","author":"Table_author__1nvPa","authorImage":"Table_authorImage__o1hdE","unreadRow":"Table_unreadRow__2lQG1"};